import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';
import { debounce } from 'lodash';

const Textbox = ({ name, label, id, formik, fullWidth = false, type }) => {

    const inputValueRef = useRef("");
    const [localValue, setLocalValue] = useState("");

    useEffect(() => {
        if (formik.values[name] !== localValue) {
            setLocalValue(formik.values[name]);
        }
    }, [formik.values[name]])

    const debouncedHandleChange = useCallback(
        debounce((value) => {
            if (inputValueRef.current === value) {
                formik.setFieldValue(name, value);
            }
        }, 300),
        [formik, name]
    );

    const handleChange = (e) => {
        const value = e.target.value;
        inputValueRef.current = value;
        setLocalValue(value);
        debouncedHandleChange(value);
    };

    return (
        <TextField
            fullWidth={fullWidth}
            type={type}
            id={id}
            autoFocus={false}
            name={name}
            label={label}
            value={localValue}
            onChange={handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched[name] && Boolean(formik.errors[name])}
            helperText={formik.touched[name] && formik.errors[name]}
        />
    )
}

export default Textbox